import { render, staticRenderFns } from "./StatisticsBarChartTemplate.vue?vue&type=template&id=4cb36dc2&"
import script from "./StatisticsBarChartTemplate.vue?vue&type=script&lang=js&"
export * from "./StatisticsBarChartTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsBarChartTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports